module.exports = __webpack_public_path__ + "img/loginArrowGreenBack.12c8d115.svg";